<template>
    <div class="users">
        <div class="row">
            <div class="filter-secition">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Kullanıcı Ara</label>
                        <div class="input-group">
                            <input class="form-control custom-input" type="text" placeholder="Ad, Soyad, E-mail...">
                            <span class="input-group-btn">
                                <a class="btn btn-primary" style="height: 45px;" @click="searchFilter">
                                    <i class="fa fa-search" style="vertical-align: -webkit-baseline-middle;"></i>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Kullanıcı Tipi</label>
                        <select class="form-control custom-input" v-model="user_type" @change="typeFilter">
                            <option value="" selected hidden disabled>Seçiniz...</option>
                            <option value="1">Yurt</option>
                            <option value="2">Öğrenci</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Üyelik Tipi</th>
                                        <th>Ad Soyad</th>
                                        <th>E-mail</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.type.type }}</td>
                                        <td>{{ item.first_name }} {{ item.last_name }}</td>
                                        <td>{{ item.email }}</td>
                                        <td>
                                            <router-link :to="{ name: 'users.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs">  Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/layouts/Pagination'
    export default {
        components: { Pagination },
        data () {
            return {
                search: '',
                user_type: '',
                icon: 'fa fa-users',
                tableName: 'Üyeler Tablosu',
                tableDesc: 'Bu tablo sitenizde aktif/pasif olan üyeleri gösterir',
                api: 'users/',
                items: [],
                pagination: {
                    'current_page': 1
                }
            }
        },

        methods: {
            fetchPosts() {
                this.$Progress.start()
                this.axios.get(this.api + '?page=' + this.pagination.current_page)
                    .then(response => {
                        this.items = response.data.data.data;
                        this.items.map(item => {
                            return item.first_name.toUpperCase();
                        });
                        this.pagination = response.data.pagination;
                        this.$Progress.finish()
                    })
                    // eslint-disable-next-line no-unused-vars
                    .catch(error => {
                        // console.log(error.response.data);
                    });
            },
            searchFilter() {
                this.$Progress.start()
                this.axios.get(this.api + '?name=' + this.search)
                    .then(response => {
                        this.items = response.data.data.data;
                        this.$Progress.finish();
                    });
            },
            typeFilter() {
                this.$Progress.start()
                this.axios.get(this.api + '?user_type=' + this.user_type)
                    .then(response => {
                        this.items = response.data.data.data;
                        // console.log(this.items);
                        this.$Progress.finish()
                    })
            }
        },
        mounted() {
            this.fetchPosts();
        },
        computed: {
            upperCase() {
                return this.items.map(item => {
                    // console.log(item.first_name);
                    return item.first_name.toUpperCase();
                });
            }
        },
    }
</script>

<style scoped>

</style>
